import { appendParams } from '@utils/func'
import { IAPI } from 'AppTypes'
import { API } from '@utils/axios'

class StoreManagement implements IAPI {
  prefix = '/StoreManagement'

  fetchList (params?: TStoreManagementAPI.Params.Search) {
    const url = `${this.prefix}/stores`
    const finalUrl = params ? appendParams(`${this.prefix}/stores`, params) : url
    return API.get<TStoreManagement.State['storeManagementListData']>(finalUrl)
  }

  fetchSingle (params: TStoreManagementAPI.Params.Detail) {
    const url = appendParams(`${this.prefix}/details`, params)
    return API.get<TStoreManagement.State['storeManagementDetail']>(url)
  }

  fetchBriefInfo (storeCD: string) {
    const url = `${this.prefix}/GetBriefInfo?storeCD=${storeCD}`
    return API.get<TStoreManagement.State['storeBriefInfo']>(url)
  }

  saveDetail (body: TStoreManagementAPI.Body.UpdateDetail) {
    return API.post<TStoreManagement.State['storeManagementDetail']>(`${this.prefix}/update`, body)
  }

  saveImages (body:any) {
    return API.patch(`${this.prefix}/updateImages`, body)
  }

  approve (body: TStoreManagementAPI.Body.Aprrove) {
    return API.post<TStoreManagementAPI.ResponseBody.Aprrove>(`${this.prefix}/approved`, body)
  }

  getTheUrldownLoadImage (imgId: string) {
    return `${API.defaults.baseURL}${this.prefix}/download?imageAttachmentId=${imgId}`
  }

  uploadExcel (formData: FormData) {
    return API.post<TStoreManagementAPI.ResponseBody.ExcelUpload>(`${this.prefix}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  uploadExcelUpdateStore (formData: FormData) {
    return API.post<TStoreManagementAPI.ResponseBody.ExcelUpload>(`${this.prefix}/UpdateStoreInfoFromFile`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  uploadExcelArea (formData: FormData) {
    return API.post<TStoreManagementAPI.ResponseBody.ExcelUpload>(`${this.prefix}/UploadAreaUrl`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  uploadNewShopIntroductionThumbnail (formData: FormData) {
    return API.post(`${this.prefix}/uploadNewShopIntroductionThumbnail`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  async uploadStorePool (formData: FormData) {
    const res = await API.post(`${this.prefix}/importStorePool`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return res.data
  }

  async downloadExcel (data: any) {
    const url = appendParams(`${API.defaults.baseURL}${this.prefix}/downloadExcel`, data)
    const response = await API.get(url, { responseType: 'blob' })
    return response.data
  }

  async getGoLiverVideoCount (params: any) {
    const response = await API.get(`${this.prefix}/CountGoLiverVideo`, { params })
    return response.data
  }

  async transferGoLiverVideos (data: any) {
    const response = await API.post(`${this.prefix}/MoveGoLiverVideo`, data)
    return response.data
  }

  async fetchStoreMarks (params: any) {
    const response = await API.get(`${this.prefix}/StoreMarkList`, { params })
    return response.data
  }

  async downloadStoreMarks (params: any) {
    const response = await API.get(`${this.prefix}/StoreMarkFile`, { params, responseType: 'blob' })
    return response.data
  }

  async updateStoreMarks (data: any) {
    const response = await API.post(`${this.prefix}/StoreMarkUpdate`, data)
    return response.data
  }

  async uploadStoreMarks (formData: FormData) {
    const response = await API.post(`${this.prefix}/StoreMarkUpload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  }

  async getShopManagerToken (params: any) {
    const response = await API.get(`${this.prefix}/GetManagerToken`, { params })
    return response.data
  }

  async updateStoreTag (params: any) {
    return API.patch(`${this.prefix}/UpdateStoreTag`, params)
  }

  async deleteNewOrderProduct (data: any) {
    const response = await API.post(`${this.prefix}/DeleteNewOrderProduct`, data)
    return response.data
  }

  async getStoreImages (id: string) {
    const response = await API.get(`${this.prefix}/GetStoreImages?storeId=${id}`)
    return response.data
  }

  async deleteStoreImage (params: any) {
    const response = await API.post(`${this.prefix}/DeleteStoreImage`, params)
    return response.data
  }
}

export const storeManagementApi = new StoreManagement()
